import React from "react";
import { simulateClick } from "@leafly-com/web-utils";
import Link from "next/link";

import { MenuItem } from "@/custom-types/MenuItem";

import StarRating from "@/components/botanic/StarRating";
import Verified from "@/components/Icons/verified.svg";

const MenuItemHeader: React.FC<{ menuItem: MenuItem }> = ({ menuItem }) => {
  if (!menuItem) {
    return null;
  }

  const handleReviewsClick = () => {
    const reviewsHeader = document.getElementById("pdp-strain-reviews");
    if (reviewsHeader) {
      reviewsHeader.scrollIntoView();
    }
  };

  return (
    <div data-testid="menu-item__header">
      <h1 className="heading--l">{menuItem.name}</h1>

      <div className="flex dot-separator">
        {menuItem.brandName && (
          <div className="text-xs mt-xs flex">
            {menuItem.brand?.slug ? (
              <Link
                data-testid="menu-item__brand"
                href={`/brands/${menuItem.brand.slug}`}
              >
                {menuItem.brandName}
              </Link>
            ) : (
              <div data-testid="menu-item__brand">{menuItem.brandName}</div>
            )}

            {menuItem.isBrandVerified ? (
              <Verified
                title={`${menuItem.brandName} is a verified brand`}
                className="text-verified  ml-xs mt-[3px]"
                data-testid="brand-verified-badge"
                height="14"
                role="img"
                width="14"
              />
            ) : null}
          </div>
        )}
        <div className="mt-xs text-xs">{menuItem.productCategory}</div>
      </div>

      {!!menuItem.strain?.averageRating && (
        <div
          data-testid="menu-item__strain-rating"
          className="flex items-center mt-sm text-xs"
        >
          <span className="mr-md font-bold">Strain rating:</span>
          <div
            className="flex items-center"
            role="button"
            onClick={handleReviewsClick}
            onKeyDown={simulateClick}
            tabIndex={0}
          >
            <StarRating
              rating={menuItem.strain?.averageRating}
              ratingCount={menuItem.strain?.reviewCount}
              starWidth={12}
              ratingCountClass="text-green underline"
            />
          </div>
        </div>
      )}

      <div
        data-testid="menu-item__cannabinoids"
        className="flex font-bold mt-sm text-xs"
      >
        {menuItem.strain?.category && (
          <div className="inline-block px-sm py-xs rounded bg-leafly-white mr-md">
            {menuItem.strain?.category}
          </div>
        )}

        {menuItem?.thcContentLabel ? (
          <div
            className="inline-block px-sm py-xs rounded bg-deep-green-20 mr-md"
            data-testid="menu-item__cannabinoids--thc"
          >
            {menuItem.thcContentLabel}
          </div>
        ) : (
          <></>
        )}

        <div
          className="inline-block px-sm py-xs rounded bg-deep-green-20"
          data-testid="menu-item__cannabinoids--cbd"
        >
          {`CBD ${menuItem?.cbdContentLabel || " —"}`}
        </div>
      </div>
    </div>
  );
};

export default MenuItemHeader;
